
import './App.css';
import {  RouterProvider, createHashRouter } from 'react-router-dom';
import Layout from './components/LayOut/Layout';
import About from './components/About/About';
import Home from './components/Home/Home';
import Projects from './components/Projects/Projects';
import LayOutHome from './components/LayOutHome/LayOutHome';
function App(prop) {
  const router = createHashRouter([


    {
      path: '/',
      element: <LayOutHome />,children: [
        {
          path: '/',
          element:  <Home />   
        }
      ]

    },
    {
      path:'',
      element: <Layout />,children: [
        {
          path: '/contact',
          element:  <About />
        },
              {
                path: '/projects',
                element:  <Projects />   
              }
      ]
    }
    // {
    //   path: '/',
    //   element: <Layout />,children: [
    //     {
    //       path: '/about',
    //       element:  <About />   
    //     },
    //     {
    //       path: '/',
    //       element:  <Home />   
    //     },
    //     {
    //       path: '/contact',
    //       element:  <Contact />   
    //     },
    //     {
    //       path: '/projects',
    //       element:  <Projects />   
    //     }
    //   ]
    // }
  ])

  
  return <RouterProvider router={router}>
    {prop.children}
  </RouterProvider>
}

export default App;
